




































































































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { namespace } from 'vuex-class';
import _ from 'lodash';
import rest from '@/rest';
import { List } from 'linq-collections';
import MediaPool from './MediaPool.vue';
import { FileDetailsVm } from '@/interfaces/FileDetailsVm';
import AudioPlayerWithSubtitles from '../Shared/AudioPlayerWithSubtitles.vue';
import ExpandableCard from '../Shared/ExpandableCard.vue';
import { exTypeItems } from '@/interfaces/Types';
import { ExType } from '@/interfaces/ExType';
import { AiModuleGeneratorVm } from '@/interfaces/AiModuleGeneratorVm';
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import SimpleMessageBox from '../Shared/SimpleMessageBox.vue';

const globals = namespace("globals");
const ux = namespace("ux");

@Component({
  components: {
    MediaPool,
    AudioPlayerWithSubtitles,
    ExpandableCard,
    SimpleMessageBox,
  }
})
export default class AiModuleCreatorDlg extends Vue {
  $refs!: {
    mediaPool: MediaPool;
    mdCreateCard: any;
  };

  @PropSync("showDialog") syncedShowDialog!: boolean;
  @globals.Getter selectedBundle: any;
  @globals.Getter selectedExercise: any;
  @globals.Action refreshSelectedBundle!: () => Promise<void>;
  @ux.Getter gradientBackground: any;
  @ux.Getter gradientBackground2: any;
  @ux.Getter gradientBackground3: any;
  @ux.Getter gradientText: any;
  @ux.State darkTheme: any;

  isBusy = false;
  isDescriptionSuggestionBusy = false;
  isTargetGroupAndToneSuggestionBusy = false;
  isValid = false;
  mdFileName: string = "";
  formData: AiModuleGeneratorVm | null = null;
  showReplaceConfirmDialog = false;
  private replaceConfirmResolver: ((value: boolean) => void) | null = null;
  // fileList: FileDetailsVm[] | null = null;
  // chatMessages: ChatMessageVm[] = [];
  exTypeItems = exTypeItems;

  private designOptions: string[] = [
    'Informativ',
    'Schlicht modern',
    'Futuristisch'
  ];

  created() {
  }

  beforeDestroy() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      await this.loadAiModuleData();
      if (this.formData && !this.formData.design) {
        this.formData!.design = this.designOptions[0];
      }
      // if (this.formData && !this.formData.language) {
      //   this.formData!.language = "Deutsch";
      // }
      if (this.formData && !this.formData.type) {
        this.formData.type = this.selectedExercise.type;
      }

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  onMediaPoolSelectionChanged() {
    if (!this.formData) return;
    this.formData.mediaAiSummaryFiles = this.$refs.mediaPool.getSelectedFiles();
    // console.log("mediaAiSummaryFiles:", this.formData.mediaAiSummaryFiles);
    const fileCount = this.formData?.mediaAiSummaryFiles?.length ?? 0;
    const moreThenOneFileSelected = fileCount > 1;
    const noFileSelected = fileCount == 0;
    if ((noFileSelected || moreThenOneFileSelected) && this.formData.aiProcessingMode === 'ExactContentFromAttachments') {
      // reset to default processing mode if more than one file is selected
      this.formData.aiProcessingMode = 'Didactical';
    }
  }

  get filesSelected(): boolean {
    return (this.formData?.mediaAiSummaryFiles?.length ?? 0) > 0;
  }

  get aiProcessingOptions() {
    // const hasFiles = (this.formData?.mediaAiSummaryFiles?.length ?? 0) > 0;
    const oneFileSelected = (this.formData?.mediaAiSummaryFiles?.length ?? 0) == 1;
    let options = [
      { text: 'Didaktisch', value: 'Didactical', disabled: false },
      { text: 'Storytelling', value: 'Storytelling', disabled: false },
      { text: 'Möglichst exakter Inhalt aus Anhang (nur eine Datei auswählen)', value: 'ExactContentFromAttachments', disabled: !oneFileSelected }, // only add this option if exact one file is selected
      { text: 'Zielgruppenfokussiert', value: 'TargetGroupFocused', disabled: false },
      { text: 'Intelligente Anreicherung', value: 'SmartEnrichment', disabled: false },
      { text: 'Microlearning', value: 'MicroLearning', disabled: false },
      { text: 'Neutral (evtl. hilfreich in Verbindung mit weiteren Anweisungen)', value: 'Neutral', disabled: false },
    ];

    return options;
  }

  // onAiProcessingModeChanged(val: string) {
  //   this.selectedAiProcessingMode = val;
  // }

  async onCreateNewMarkdownFile() {
    if (!this.mdFileName || this.mdFileName.trim() == "") return;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] = this.selectedBundle.id!.toString();
    params.dictionary!["FileName"] = this.mdFileName.trim();

    await rest.url("contentManager/createNewMarkdownFile").post(params);
    this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list
    if (this.formData) {
      this.formData.mediaAiSummaryFiles = [];
    }

    // Close the ExpandableCard after successful creation
    this.$nextTick(() => {
      this.$refs.mdCreateCard?.collapse?.();
    });

    this.mdFileName = "";
  }

  async loadAiModuleData() {
    this.formData = null;
    this.formData = await rest.url("contentManager/getAiModuleCreatorData")
      .query({ exerciseId: this.selectedExercise.id })
      .get();

    if (this.formData) {
      this.formData.replaceExistingPages = false; // reset to avoid accidental override of existing pages
      if (!this.formData.aiProcessingMode) {
         this.formData.aiProcessingMode = 'Didactical';
      }
    }
  }

  async saveAiModuleData() {
    this.isBusy = true;
    await rest.url("contentManager/saveAiModuleCreatorData")
      .post(this.formData)
      .then((response) => {
      })
      .finally(() => {
        this.isBusy = false;
      });
  }

  async onTargetGroupAndToneSuggestion() {
    this.isTargetGroupAndToneSuggestionBusy = true;
    await rest.url("contentManager/suggestAiModuleTargetGroupAndTone")
      .post(this.formData)
      .then((response) => {
        if (! this.formData) return;
        this.formData.targetGroup = response.targetGroup;
        this.formData.tone = response.tone;
      })
      .finally(() => {
        this.isTargetGroupAndToneSuggestionBusy = false;
      });
  }

  async onDescriptionSuggestion() {
    this.isDescriptionSuggestionBusy = true;
    await rest.url("contentManager/suggestAiModuleDescription")
      .post(this.formData)
      .then((response) => {
        if (! this.formData) return;
        this.formData.description = response.description;
      })
      .finally(() => {
        this.isDescriptionSuggestionBusy = false;
      });
  }

  confirmReplaceExistingPages() {
    if (this.formData?.replaceExistingPages ?? false) {
    this.showReplaceConfirmDialog = true;
    } else {
      this.onCreateModulePages();
    }
  }

  async onCreateModulePages() {
    await this.saveAiModuleData();
    this.isBusy = true;

    await rest.url("contentManager/createAiModulePages")
      .post(this.formData)
      .then((response) => {
        // console.log("createAiModulePages response", response);

        this.$root.$emit('moduleUpdated:CourseCreator', this.formData);
        this.syncedShowDialog = false;
      })
      .finally(async () => {
        this.isBusy = false;
        await this.refreshSelectedBundle();
      });
  }

  // get allFilesProcessed(): boolean {
  //   if (this.fileList == null || this.fileList.length == 0) return true;

  //   return this.fileList.filter(file => file.hasAiSummary).length == this.fileList.length;
  // }

  getExerciseIcon(type: string | null): string {
    return exTypeItems.find(i => ExType[i.value] == type)?.icon || "mdi-help-circle-outline";
  }

  // async complete() {
  //   await this.saveAiModuleData();
  //   // this.$emit('complete:AiModuleCreatorDlg', this.formData);
  //   rest.url("contentManager/createCourseModule")
  //     .post(this.formData)
  //     .then((response) => {
  //       // this.$emit('complete:AiModuleCreatorDlg', response);
  //       this.syncedShowDialog = false;
  //     })
  //     .finally(() => {
  //       this.isBusy = false;
  //     });
  // }

  async onClose() {
    await this.saveAiModuleData();
    this.syncedShowDialog = false;
  }

  get dialogBackground() {
    if (this.darkTheme)
      return "#616161";
    else
      return "#d0d0d0";
  }
}
